<template>
  <v-dialog persistent eager v-model="dialog" max-width="800">
    <v-card>
      <v-alert v-if="record.actualizado" dark color="warning"
        >Registro Actualizado</v-alert
      >
      <v-alert v-if="record.nuevo" dark color="success"
        >Registro Creado</v-alert
      >
      <v-card-title>
        {{ model.id ? "Editar" : "Nueva" }} Convocatoria
        <v-btn link icon absolute top right @click="cerrar"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                label="Número de Convocatoria"
                v-model="model.numero"
                placeholder="Ej: 02/26"
                :error-messages="errors.numero"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                outlined
                label="Año"
                v-model="model.anio"
                :items="anios"
                :error-messages="errors.anio"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                outlined
                label="Formación"
                v-model="model.formacion"
                :items="formaciones"
                item-text="text"
                item-value="value"
                :error-messages="errors.formacion"
              ></v-select>
            </v-col>
          </v-row>

          <v-text-field
            outlined
            label="Disposición"
            v-model="model.disposicion"
            placeholder="Ej: Disp. 14/26 del Consejo Directivo"
            :error-messages="errors.disposicion"
          ></v-text-field>

          <v-text-field
            outlined
            label="Institución"
            v-model="model.institucion"
            :error-messages="errors.institucion"
          ></v-text-field>

          <v-text-field
            outlined
            label="Resolución Marco"
            v-model="model.resolucion_marco"
            placeholder="Ej: Res. 589/26"
            :error-messages="errors.resolucion_marco"
          ></v-text-field>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                label="Fecha Inicio Inscripción"
                type="date"
                v-model="model.fecha_inicio_inscripcion"
                :error-messages="errors.fecha_inicio_inscripcion"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                label="Fecha Fin Inscripción"
                type="date"
                v-model="model.fecha_fin_inscripcion"
                :error-messages="errors.fecha_fin_inscripcion"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                label="Hora de Cierre"
                type="time"
                v-model="model.hora_cierre"
                :error-messages="errors.hora_cierre"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>
          <h3 class="mb-3">Datos del Cargo</h3>

          <v-text-field
            outlined
            label="Carrera"
            v-model="model.carrera"
            placeholder="Ej: GUARDAVIDAS"
            :error-messages="errors.carrera"
          ></v-text-field>

          <v-text-field
            outlined
            label="Plan de Estudio"
            v-model="model.plan_estudio"
            placeholder="Ej: Plan Nº 6633/22"
            :error-messages="errors.plan_estudio"
          ></v-text-field>

          <v-text-field
            outlined
            label="Unidad Curricular"
            v-model="model.unidad_curricular"
            placeholder="Ej: Educación Sanitaria"
            :error-messages="errors.unidad_curricular"
          ></v-text-field>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                label="Carga Horaria"
                v-model="model.carga_horaria"
                placeholder="Ej: 2 horas cátedra"
                :error-messages="errors.carga_horaria"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                label="Origen de la Vacante"
                v-model="model.origen_vacante"
                placeholder="Ej: Res. 2309/23"
                :error-messages="errors.origen_vacante"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-select
                outlined
                label="Carácter"
                v-model="model.caracter"
                :items="caracteres"
                :error-messages="errors.caracter"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                outlined
                label="Régimen de Cursada"
                v-model="model.regimen_cursada"
                :items="regimenes"
                :error-messages="errors.regimen_cursada"
              ></v-select>
            </v-col>
          </v-row>

          <v-textarea
            outlined
            label="Día y Horario de Cursada"
            v-model="model.horario_cursada"
            rows="2"
            placeholder="Ej: Lunes de 18:00 a 20:00&#10;Miércoles de 18:00 a 20:00"
            :error-messages="errors.horario_cursada"
          ></v-textarea>

          <v-textarea
            outlined
            label="Perfil Profesional Requerido"
            v-model="model.perfil_profesional"
            rows="3"
            :error-messages="errors.perfil_profesional"
          ></v-textarea>

          <v-textarea
            outlined
            label="Observaciones"
            v-model="model.observaciones"
            rows="4"
            :error-messages="errors.observaciones"
          ></v-textarea>

          <v-switch
            :true-value="1"
            :false-value="0"
            v-model="model.estado"
            :label="model.estado ? 'Activo' : 'Inactivo'"
          ></v-switch>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="guardar" color="primary">Guardar</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "ConvocatoriaForm",
  props: {
    id: [String, Number],
  },
  data() {
    return {
      dialog: false,
      model: {
        estado: 1,
        formacion: "tecnica",
        institucion: "Instituto de Formación Docente de San Antonio Oeste",
        hora_cierre: "13:00",
      },
      anios: [2030, 2029, 2028, 2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020],
      caracteres: ["Interino", "Suplente", "Titular"],
      regimenes: ["Primer Cuatrimestre", "Segundo Cuatrimestre", "Anual"],
      formaciones: [
        { text: "Técnica", value: "tecnica" },
        { text: "Docente", value: "docente" },
      ],
    };
  },
  computed: {
    ...mapGetters("ConvocatoriaModule", ["errors"]),
    ...mapState("ConvocatoriaModule", ["fields", "convocatoria", "record"]),
  },
  methods: {
    ...mapActions("ConvocatoriaModule", [
      "getFields",
      "getConvocatoria",
      "updateConvocatoria",
      "addConvocatoria",
    ]),

    async getModel() {
      await this.getConvocatoria({ id: this.id });
      this.model = { ...this.convocatoria };
    },

    async guardar() {
      this.model.id
        ? await this.updateConvocatoria(this.model)
        : await this.addConvocatoria(this.model);
    },

    cerrar() {
      this.record.actualizado = false;
      this.record.nuevo = false;
      this.$emit("close");
    },

    resetModel() {
      this.model = {
        estado: 1,
        formacion: "tecnica",
        institucion: "Instituto de Formación Docente de San Antonio Oeste",
        hora_cierre: "13:00",
      };
    },
  },
  watch: {
    id() {
      if (this.id) {
        this.getModel();
      }
    },
  },
  created() {
    this.getFields();
    if (this.id) {
      this.getModel();
    }
  },
};
</script>

<style scoped></style>
